<template>
	<div id="app">
		<el-row class="tac">
			<el-col :xs="24" :sm="24" :lg="4">
				<Sidebar />
			</el-col>
			<el-col :xs="24" :sm="24" :lg="20">
				<router-view></router-view> <!-- 这里会渲染当前路由对应的组件 -->
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import Sidebar from './components/Sidebar.vue'

	export default {
		name: 'App',
		components: {
			Sidebar
		}
	}
</script>

<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		/* text-align: center; */
		color: #2c3e50;
		width: 96%;
		padding: 0 2%;
		max-width: 1380px;
		margin: 10px auto;
	}
</style>